import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  createFilterOptions,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useHistory, useParams } from "react-router";
import api from "../../../components/services/api";
import { useEffect } from "react";
import Swal from "sweetalert2";
import moment from "moment";
import { saveAs } from "file-saver";
import mime from "mime";
export default function Cost() {
  const filter = createFilterOptions();
  const history = useHistory();
  const [bodyPrint, setBodyPrint] = useState({
    CostType: "Train%20Cost",
    CostId: "",
  });
  const [loading, setLoading] = useState(false);

  const { voyNo, TrainRouteId } = useParams();
  const [addInvoice, setAddInvoice] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [issueDate, setIssueDate] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [cost, setCost] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [agentName, setAgentName] = useState("");
  const [billTo, setBillTo] = useState(null);
  const [company, setCompany] = useState([]);
  const [rows, setRows] = useState([]);
  const [MasterCost, setMasterCost] = useState([]);
  const [currencyId, setCurrencyId] = useState("");
  const [vat, setVat] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [masterCompany, setMasterCompany] = useState([]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      TrainCostDetailId: null,
      Charge: "",
      TaxPercent: 0,
      Quantity: 0,
      PricePerUnit: 0,
      Currency: "",
      ExchangeRate: 1,
      Amount: 0,
      TaxAmount: 0,
      WithholdingTaxAmount: 0,
      TotalAmount: 0,
      AmountTHB: 0,
      TaxAmountTHB: 0,
      WithholdingTaxAmountTHB: 0,
      TotalAmountTHB: 0,
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e) => i !== e?.id);
    setRows(data);
  };

  const getCost = async () => {
    try {
      const data = await api.get(`api/train/detail/cost/${voyNo}`);
      setCost(data?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getVat = async () => {
    const res = await api.get(`api/master/Vatvalue`);
    const data = await res.data.data;
    if (res.meta.status === true) {
      setVat(data);
    }
  };
  const getCompany = async () => {
    try {
      const res = await api.get(`api/master/company`);
      setCompany(res?.data?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getCurrency = async () => {
    try {
      const res = await api.get(`api/master/currency`);
      setCurrency(res?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };

  const getTemplate = async () => {
    try {
      const res = await api.get(
        `api/train/detail/cost/template/${TrainRouteId}/${voyNo}`
      );
      const data = res.data;
      setIssueDate(data.IssueDate);
      setInvoiceNo(data.setInvoiceNo);
      setAgentName(data.AgentName);
      setBillTo(data.BillTo);
      setRows(data.Detail);
      setAddInvoice(true);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    const getMasterCost = async () => {
      try {
        const res = await api.get(`/api/master/cost/Train%20Cost`);
        setMasterCost(res?.data);

        //   setLog_data_length(3);
      } catch (e) {
        console.log(e);
      }
    };
    getMasterCost();
  }, []);
  //   const getMasterCostType = async () => {
  //     try {
  //       const res = await api.get(`api/master/costtype`);
  //       setMasterCostType(res?.data);

  //       //   setLog_data_length(3);
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   };
  const getMasterCompany = async () => {
    const res = await api.get(`api/master/company`);
    const data = await res.data.data;
    if (res.meta.status === true) {
      setMasterCompany(data);
    }
  };
  useEffect(() => {
    getCost();
    getCompany();
    getVat();
    // getMasterCostType()
    getCurrency();
    getMasterCompany()
  }, []);
  const updateFieldAndTotals = (rows, data, fieldName, value) => {
    const body = rows.map((v) => {
      if (v.id === data.id) {
        const updatedRow = {
          ...v,
          [fieldName]: value,
        };

        const updatedTotal = +updatedRow.Quantity * +updatedRow.PricePerUnit;
        const updatedTotalTax =
          updatedTotal * (+(+updatedRow.TaxPercent || 0) / 100);
        const updatedWithholdingTax =
          updatedTotal * (+(updatedRow.WithholdingTaxPercent || 0) / 100);
        const updatedTotalAmount =
          updatedTotal + (updatedTotalTax - updatedWithholdingTax);
        const updatedTotalTHB = updatedTotal * +updatedRow.ExchangeRate;
        const updatedTotalTaxTHB = updatedTotalTax * +updatedRow.ExchangeRate;
        const updatedWithholdingTaxTHB =
          updatedWithholdingTax * +updatedRow.ExchangeRate;
        const updatedTotalAmountTHB =
          updatedTotalAmount * +updatedRow.ExchangeRate;

        return {
          ...updatedRow,
          Amount: updatedTotal,
          TaxAmount: updatedTotalTax,
          WithholdingTaxAmount: updatedWithholdingTax,
          TotalAmount: updatedTotalAmount,
          AmountTHB: updatedTotalTHB,
          TaxAmountTHB: updatedTotalTaxTHB,
          WithholdingTaxAmountTHB: updatedWithholdingTaxTHB,
          TotalAmountTHB: updatedTotalAmountTHB,
        };
      }

      return v;
    });
    setRows(body);
  };
  const download = async (CostType, CostId, CompanyCode) => {
    setLoading(true)
    await api.get(`api/report/cost-request-form/download/pdf?CostType=${CostType}&CostId=${CostId}&CompanyCode=${CompanyCode}`, {
      responseType: "blob",
      timeout: 30000
    })
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.[pdf]", {
          type: mime.getType(".pdf"),

        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, `train-cost-request-form-${CompanyCode}.pdf`);
        setLoading(false)
      }).catch((errpr) => {
        setLoading(false)
      })
  }
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            ค่าใช้จ่าย
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Cost #{voyNo}
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">TrainSchedule </Typography>
              <Typography>
                <span>&nbsp;</span> / Cost
              </Typography>
            </Grid>
          </Grid>

          <Grid
            //   container
            //   sx={{ justifyContent: "end" }}
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                width: "100%",
                marginTop: "10px",
                paddingBottom: "24px",
              }}
            >
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="button"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                }}
                disabled={isEdit !== false ? true : false}
                onClick={() => getTemplate()}
              >
                <AddIcon /> Add Invoice
              </Button>
              {addInvoice && (
                <Card
                  variant="outlined"
                  sx={{
                    marginTop: "25px",
                    padding: "40px",
                    boxShadow:
                      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
                  }}
                >
                  <Grid container>
                    <Grid xs={4} sx={{ marginRight: "15px" }}>
                      <TextField
                        value={invoiceNo}
                        onChange={(e) => setInvoiceNo(e.target.value)}
                        fullWidth
                        label="Invoice No."
                        variant="outlined"
                      />
                    </Grid>
                    <Grid xs={4}>
                      <DesktopDatePicker
                        label="Issue Date"
                        inputFormat="yyyy/MM/dd"
                        // disablePast
                        onChange={(newValue) => {
                          setIssueDate(newValue);
                        }}
                        value={issueDate}
                        renderInput={(params) => (
                          <TextField sx={{ width: "100%" }} {...params} />
                        )}
                      />
                    </Grid>
                    <Grid
                      xs={4}
                      sx={{ marginRight: "15px", marginTop: "15px" }}
                    >
                      <Autocomplete
                        freeSolo
                        options={company}
                        getOptionLabel={(option) => {
                          if (typeof option === "string") {
                            return option;
                          }
                          // Add "xxx" option created dynamically
                          if (option.inputValue) {
                            return option.inputValue;
                          }
                          // Regular option
                          return option?.CompanyName;
                        }}
                        id="controlled-demo"
                        value={billTo}
                        onChange={(event, newValue) => {
                          if (typeof newValue === "string") {
                            setBillTo({
                              CompanyName: newValue,
                            });
                          } else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                            setBillTo({
                              CompanyName: newValue.inputValue,
                            });
                          } else {
                            setBillTo(newValue);
                          }
                        }}
                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);

                          const { inputValue } = params;
                          // Suggest the creation of a new value
                          const isExisting = options.some(
                            (option) => inputValue === option.CompanyName
                          );
                          if (inputValue !== "" && !isExisting) {
                            filtered.push({
                              inputValue,
                              CompanyName: `Add "${inputValue}"`,
                            });
                          }

                          return filtered;
                        }}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        renderInput={(params) => (
                          <TextField {...params} label="Bill To" />
                        )}
                      />
                    </Grid>
                    <Grid
                      xs={4}
                      sx={{ marginRight: "15px", marginTop: "15px" }}
                    >
                      <TextField
                        label="Agent Name"
                        value={agentName}
                        onChange={(e) => {
                          setAgentName(e.target.value);
                        }}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    type="button"
                    variant="contained"
                    // disabled={costType ? false : true}
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginTop: "10px",
                    }}
                    onClick={addRow}
                  >
                    <AddIcon /> Add
                  </Button>
                  <div style={{ overflowX: "auto" }}>
                    <TableContainer
                      sx={{ marginTop: 2, marginBottom: 2, width: "200%" }}
                    >
                      <Table stickyHeader>
                        <TableRow>
                          <TableCell align="center" width="100px">
                            #
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Charge
                          </TableCell>

                          <TableCell align="center" width="100px">
                            Tax%
                          </TableCell>
                          <TableCell align="center" width="150px">
                            Withholding Tax%
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Quantity
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Price / Unit
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Currency
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Exchang Rate
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Amount
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Tax Amount
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Withholding Tax
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Total Amount
                          </TableCell>
                          <TableCell align="center" width="100px">
                            Amount (THB)
                          </TableCell>
                          <TableCell align="center" width="120px">
                            Tax Amount (THB)
                          </TableCell>
                          <TableCell align="center" width="130px">
                            Withholding Tax (THB)
                          </TableCell>
                          <TableCell align="center" width="120px">
                            Total Amount (THB)
                          </TableCell>
                          <TableCell align="center" width="100px"></TableCell>

                          {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                        </TableRow>

                        {rows?.map((data, index) => {
                          return (
                            <TableBody key={index}>
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="center">
                                <FormControl sx={{ width: "300px" }}>
                                  <InputLabel>Charge</InputLabel>
                                  <Select
                                    label="Charge"
                                    value={data?.Charge}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => {
                                      const io = rows?.map((v) => {
                                        v.Charge =
                                          v?.id === data?.id
                                            ? e.target.value
                                            : v?.Charge;
                                        v.Currency =
                                          v?.id === data?.id
                                            ? MasterCost.find(
                                                (x) =>
                                                  x?.CostName === e.target.value
                                              )?.CurrencyId
                                            : v?.Currency;
                                        v.PricePerUnit =
                                          v?.id === data?.id
                                            ? MasterCost.find(
                                                (x) =>
                                                  x?.CostName === e.target.value
                                              )?.CostPrice
                                            : +v?.PricePerUnit;
                                        return v;
                                      });

                                      setRows([...io]);
                                    }}
                                  >
                                    {MasterCost?.map((x) => (
                                      <MenuItem value={x?.CostName}>
                                        {x?.CostName}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </TableCell>

                              <TableCell align="center">
                                <FormControl fullWidth>
                                  <InputLabel>Tax</InputLabel>
                                  <Select
                                    label="Tax"
                                    value={data?.TaxPercent || ""}
                                    onChange={(e) => {
                                      updateFieldAndTotals(
                                        rows,
                                        data,
                                        "TaxPercent",
                                        e.target.value
                                      );
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                  >
                                    {vat?.map((x) => (
                                      <MenuItem value={x?.VatvalueNumber}>
                                        {x?.VatvalueNumber}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </TableCell>
                              <TableCell align="center">
                                <FormControl fullWidth>
                                  <InputLabel>Withholding Tax</InputLabel>
                                  <Select
                                    label="Withholding Tax"
                                    value={data?.WithholdingTaxPercent || ""}
                                    onChange={(e) => {
                                      updateFieldAndTotals(
                                        rows,
                                        data,
                                        "WithholdingTaxPercent",
                                        e.target.value
                                      );
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                  >
                                    {vat?.map((x) => (
                                      <MenuItem value={x?.VatvalueNumber}>
                                        {x?.VatvalueNumber}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Quantity"
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={data?.Quantity}
                                  onChange={(e) => {
                                    updateFieldAndTotals(
                                      rows,
                                      data,
                                      "Quantity",
                                      e.target.value
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Price/Unit"
                                  value={data?.PricePerUnit}
                                  type="number"
                                  sx={{
                                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                      {
                                        display: "none",
                                      },
                                    "& input[type=number]": {
                                      MozAppearance: "textfield",
                                    },
                                  }}
                                  onChange={(e) => {
                                    updateFieldAndTotals(
                                      rows,
                                      data,
                                      "PricePerUnit",
                                      e.target.value
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <FormControl fullWidth>
                                  <InputLabel>Currency</InputLabel>
                                  <Select
                                    label="Currency"
                                    value={data?.Currency || ""}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => {
                                      updateFieldAndTotals(
                                        rows,
                                        data,
                                        "CurrencyId",
                                        e.target.value
                                      );
                                    }}
                                  >
                                    {currency?.map((x) => (
                                      <MenuItem value={x?.CurrencyId}>
                                        {x?.CurrencyCode}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Exchang Rate"
                                  value={data?.ExchangeRate || ""}
                                  // value={data?.ExchangeRate}
                                  onChange={(e) => {
                                    updateFieldAndTotals(
                                      rows,
                                      data,
                                      "ExchangeRate",
                                      e.target.value
                                    );
                                  }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Amount"
                                  value={+data.Amount?.toFixed(2)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Tax Amount"
                                  value={+data.TaxAmount?.toFixed(2)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Withholding Tax"
                                  value={+data.WithholdingTaxAmount?.toFixed(2)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Total Amount"
                                  value={+data.TotalAmount?.toFixed(2)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Amount"
                                  value={+data.AmountTHB?.toFixed(2)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Tax Amount"
                                  value={+data.TaxAmountTHB?.toFixed(2)}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Withholding Tax"
                                  value={
                                    +data.WithholdingTaxAmountTHB?.toFixed(2)
                                  }
                                />
                              </TableCell>
                              <TableCell align="center">
                                <TextField
                                  label="Total Amount"
                                  value={+data.TotalAmountTHB?.toFixed(2)}
                                />
                              </TableCell>

                              <TableCell align="center">
                                <Button
                                  type="button"
                                  variant="outlined"
                                  style={{
                                    color: "#80c340",
                                    borderColor: "#80c340",
                                  }}
                                  onClick={() => deletehand(data?.id)}
                                >
                                  Delete
                                </Button>
                              </TableCell>
                            </TableBody>
                          );
                        })}
                      </Table>
                    </TableContainer>
                  </div>
                  <Table sx={{ marginBottom: "15px" }}>
                    <TableRow>
                      <TableCell align="center" width="40%"></TableCell>
                      <TableCell align="center" width="20%"></TableCell>
                      <TableCell align="center" width="30%"></TableCell>
                      <TableCell align="center" width="10%"></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={1} rowSpan={4} />
                      <TableCell colSpan={1}>
                        Total Amount (Excluding Tax)
                      </TableCell>
                      <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                        {parseFloat(
                          rows?.length > 1
                            ? rows
                                ?.map((s) => s?.AmountTHB || 0)
                                ?.reduce((a, b) => a + b)
                                .toFixed(2)
                            : rows?.length === 1
                            ? rows[0]?.AmountTHB.toFixed(2)
                            : 0,
                          10
                        )
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                      </TableCell>
                      <TableCell colSpan={1}>THB</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={1}>Withholding Tax</TableCell>
                      <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                        {parseFloat(
                          rows?.length > 1
                            ? rows
                                ?.map((s) => s?.WithholdingTaxAmountTHB || 0)
                                ?.reduce((a, b) => a + b)
                                .toFixed(2)
                            : rows?.length === 1
                            ? rows[0]?.WithholdingTaxAmountTHB.toFixed(2)
                            : 0,
                          10
                        )
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                      </TableCell>
                      <TableCell colSpan={1}>THB</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={1}>TotalTax</TableCell>
                      <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                        {parseFloat(
                          rows?.length > 1
                            ? rows
                                ?.map((s) => s?.TaxAmountTHB || 0)
                                ?.reduce((a, b) => a + b)
                                .toFixed(2)
                            : rows?.length === 1
                            ? rows[0]?.TaxAmountTHB.toFixed(2)
                            : 0,
                          10
                        )
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                      </TableCell>
                      <TableCell colSpan={1}>THB</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={1}>TotalAmount</TableCell>
                      <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                        {parseFloat(
                          rows?.length > 1
                            ? rows
                                ?.map((s) => s?.TotalAmountTHB || 0)
                                ?.reduce((a, b) => a + b)
                                .toFixed(2)
                            : rows?.length === 1
                            ? (rows[0]?.TotalAmountTHB).toFixed(2)
                            : 0,
                          10
                        )
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                      </TableCell>
                      <TableCell colSpan={1}>THB</TableCell>
                    </TableRow>
                  </Table>
                  <Box sx={{ display: "flex", justifyContent: "end" }}>
                    <Box sx={{ display: "flex" }}>
                      <Button
                        type="button"
                        variant="contained"
                        style={{
                          background: "#d33",
                          borderColor: "#d33",
                          marginRight: "10px",
                        }}
                        onClick={() => {
                          setRows([]);
                          setAddInvoice(false);
                          setCurrencyId("");
                          setInvoiceNo("");
                          setIssueDate(null);
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        // type="button"
                        disabled={invoiceNo && issueDate ? false : true}
                        variant="contained"
                        style={{
                          background: "#80c340",
                          borderColor: "#80c340",
                        }}
                        onClick={() => {
                          const body = {
                            TrainCostId: null,
                            VoyNo: voyNo,
                            InvoiceNo: invoiceNo,
                            IssueDate: moment(issueDate).format("yyyy-MM-DD"),
                            BillTo: billTo?.CompanyName,
                            AgentName: agentName,
                            TotalTHB:
                              rows?.length > 1
                                ? rows
                                    ?.map((s) => s?.AmountTHB)
                                    ?.reduce((a, b) => a + b)
                                : rows?.length === 1
                                ? rows[0]?.AmountTHB
                                : 0,
                            TaxAmountTHB:
                              rows?.length > 1
                                ? +rows
                                    ?.map((s) => s?.TaxAmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? +rows[0]?.TaxAmountTHB.toFixed(2)
                                : 0,
                            WithholdingTaxAmountTHB:
                              rows?.length > 1
                                ? +rows
                                    ?.map((s) => s?.WithholdingTaxAmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? +rows[0]?.WithholdingTaxAmountTHB.toFixed(2)
                                : 0,
                            TotalAmountTHB:
                              rows?.length > 1
                                ? +rows
                                    ?.map((s) => s?.TotalAmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? +(rows[0]?.TotalAmountTHB).toFixed(2)
                                : 0,
                            Status: true,
                            Detail: rows,
                          };
                          const postInvoice = async () => {
                            const res = await api.post(
                              `api/train/update/cost/invoice`,
                              body
                            );
                            if (res.meta.status) {
                              Swal.fire({
                                title: `${res.meta.message}`,
                                icon: "success",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  setRows([]);
                                  setAddInvoice(false);
                                  // setCurrencyId('')
                                  setInvoiceNo("");
                                  setIssueDate(null);
                                  setBillTo(null);
                                  // setExchangeRate('')
                                  getCost();
                                }
                              });
                            }
                          };
                          // console.log(body)
                          postInvoice();
                        }}
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                </Card>
              )}
              {cost?.map((x, i) => (
                <Card
                  variant="outlined"
                  sx={{
                    marginTop: "25px",
                    padding: "40px",
                    boxShadow:
                      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
                  }}
                >
                  <Grid container>
                    <Grid xs={4} sx={{ marginRight: "15px" }}>
                      <TextField
                        value={x.InvoiceNo}
                        disabled={isEdit !== x?.TrainCostId}
                        onChange={(e) => {
                          const io = cost?.map((v) => {
                            v.InvoiceNo =
                              v?.TrainCostId === x?.TrainCostId
                                ? e.target.value
                                : v?.InvoiceNo;

                            return v;
                          });
                          setCost([...io]);
                        }}
                        fullWidth
                        label="Invoice No."
                        variant="outlined"
                      />
                    </Grid>
                    <Grid xs={4}>
                      <DesktopDatePicker
                        disabled={isEdit !== x?.TrainCostId}
                        label="Issue Date"
                        inputFormat="yyyy/MM/dd"
                        onChange={(newValue) => {
                          setIssueDate(newValue);
                          const io = cost?.map((v) => {
                            v.IssueDate =
                              v?.TrainCostId === x?.TrainCostId
                                ? moment(newValue).format("yyyy-MM-DD")
                                : v?.IssueDate;

                            return v;
                          });

                          setCost([...io]);
                        }}
                        value={x.IssueDate}
                        renderInput={(params) => (
                          <TextField sx={{ width: "100%" }} {...params} />
                        )}
                      />
                    </Grid>
                    <Grid
                      xs={4}
                      sx={{ marginRight: "15px", marginTop: "15px" }}
                    >
                      <Autocomplete
                        disabled={isEdit !== x?.TrainCostId}
                        freeSolo
                        options={company}
                        getOptionLabel={(option) => {
                          if (typeof option === "string") {
                            return option;
                          }
                          // Add "xxx" option created dynamically
                          if (option.inputValue) {
                            return option.inputValue;
                          }
                          // Regular option
                          return option?.CompanyName;
                        }}
                        id="controlled-demo"
                        value={
                          billTo || company.length > 0
                            ? company?.find((c) => c?.CompanyName == x?.BillTo)
                            : null
                        }
                        onChange={(event, newValue) => {
                          if (typeof newValue === "string") {
                            setBillTo({
                              CompanyName: newValue,
                            });
                          } else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                            setBillTo({
                              CompanyName: newValue.inputValue,
                            });
                          } else {
                            setBillTo(newValue);
                          }
                        }}
                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);

                          const { inputValue } = params;
                          // Suggest the creation of a new value
                          const isExisting = options.some(
                            (option) => inputValue === option.CompanyName
                          );
                          if (inputValue !== "" && !isExisting) {
                            filtered.push({
                              inputValue,
                              CompanyName: `Add "${inputValue}"`,
                            });
                          }

                          return filtered;
                        }}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        renderInput={(params) => (
                          <TextField {...params} label="Bill To" />
                        )}
                      />
                    </Grid>
                    <Grid
                      xs={4}
                      sx={{ marginRight: "15px", marginTop: "15px" }}
                    >
                      <TextField
                        label="Agent Name"
                        value={x.AgentName}
                        disabled={isEdit !== x?.TrainCostId}
                        onChange={(e) => {
                          const io = cost?.map((v) => {
                            v.AgentName =
                              v?.TrainCostId === x?.TrainCostId
                                ? e.target.value
                                : v?.AgentName;

                            return v;
                          });
                          setCost([...io]);
                        }}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                  </Grid>

                  {isEdit == x?.TrainCostId ? (
                    <>
                      <Button
                        type="button"
                        variant="contained"
                        style={{
                          background: "#80c340",
                          borderColor: "#80c340",
                          marginTop: "10px",
                        }}
                        onClick={addRow}
                      >
                        <AddIcon /> Add
                      </Button>
                      <div style={{ overflowX: "auto" }}>
                        <TableContainer
                          sx={{ marginTop: 2, marginBottom: 2, width: "200%" }}
                        >
                          <Table stickyHeader>
                            <TableRow>
                              <TableCell align="center" width="100px">
                                #
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Charge
                              </TableCell>

                              <TableCell align="center" width="100px">
                                Tax%
                              </TableCell>
                              <TableCell align="center" width="150px">
                                Withholding Tax%
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Quantity
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Price / Unit
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Currency
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Exchang Rate
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Amount
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Tax Amount
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Withholding Tax
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Total Amount
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Amount (THB)
                              </TableCell>
                              <TableCell align="center" width="120px">
                                Tax Amount (THB)
                              </TableCell>
                              <TableCell align="center" width="130px">
                                Withholding Tax (THB)
                              </TableCell>
                              <TableCell align="center" width="120px">
                                Total Amount (THB)
                              </TableCell>
                              <TableCell
                                align="center"
                                width="100px"
                              ></TableCell>

                              {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                            </TableRow>

                            {rows?.map((data, index) => {
                              return (
                                <TableBody key={index}>
                                  <TableCell align="center">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell align="center">
                                    <FormControl sx={{ width: "300px" }}>
                                      <InputLabel>Charge</InputLabel>
                                      <Select
                                        label="Charge"
                                        value={data?.Charge}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => {
                                          const io = rows?.map((v) => {
                                            v.Charge =
                                              v?.id === data?.id
                                                ? e.target.value
                                                : v?.Charge;
                                            v.Currency =
                                              v?.id === data?.id
                                                ? MasterCost.find(
                                                    (x) =>
                                                      x?.CostName ===
                                                      e.target.value
                                                  )?.CurrencyId
                                                : v?.Currency;
                                            v.PricePerUnit =
                                              v?.id === data?.id
                                                ? MasterCost.find(
                                                    (x) =>
                                                      x?.CostName ===
                                                      e.target.value
                                                  )?.CostPrice
                                                : +v?.PricePerUnit;
                                            return v;
                                          });

                                          setRows([...io]);
                                        }}
                                      >
                                        {MasterCost?.map((x) => (
                                          <MenuItem value={x?.CostName}>
                                            {x?.CostName}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </TableCell>

                                  <TableCell align="center">
                                    <FormControl fullWidth>
                                      <InputLabel>Tax</InputLabel>
                                      <Select
                                        label="Tax"
                                        value={data?.TaxPercent || ""}
                                        onChange={(e) => {
                                          updateFieldAndTotals(
                                            rows,
                                            data,
                                            "TaxPercent",
                                            e.target.value
                                          );
                                        }}
                                        InputLabelProps={{ shrink: true }}
                                      >
                                        {vat?.map((x) => (
                                          <MenuItem value={x?.VatvalueNumber}>
                                            {x?.VatvalueNumber}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </TableCell>
                                  <TableCell align="center">
                                    <FormControl fullWidth>
                                      <InputLabel>Withholding Tax</InputLabel>
                                      <Select
                                        label="Withholding Tax"
                                        value={
                                          data?.WithholdingTaxPercent || ""
                                        }
                                        onChange={(e) => {
                                          updateFieldAndTotals(
                                            rows,
                                            data,
                                            "WithholdingTaxPercent",
                                            e.target.value
                                          );
                                        }}
                                        InputLabelProps={{ shrink: true }}
                                      >
                                        {vat?.map((x) => (
                                          <MenuItem value={x?.VatvalueNumber}>
                                            {x?.VatvalueNumber}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Quantity"
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      value={data?.Quantity}
                                      onChange={(e) => {
                                        updateFieldAndTotals(
                                          rows,
                                          data,
                                          "Quantity",
                                          e.target.value
                                        );
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Price/Unit"
                                      value={data?.PricePerUnit}
                                      type="number"
                                      sx={{
                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                          {
                                            display: "none",
                                          },
                                        "& input[type=number]": {
                                          MozAppearance: "textfield",
                                        },
                                      }}
                                      onChange={(e) => {
                                        updateFieldAndTotals(
                                          rows,
                                          data,
                                          "PricePerUnit",
                                          e.target.value
                                        );
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <FormControl fullWidth>
                                      <InputLabel>Currency</InputLabel>
                                      <Select
                                        label="Currency"
                                        value={data?.Currency || ""}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => {
                                          updateFieldAndTotals(
                                            rows,
                                            data,
                                            "Currency",
                                            e.target.value
                                          );
                                        }}
                                      >
                                        {currency?.map((x) => (
                                          <MenuItem value={x?.CurrencyId}>
                                            {x?.CurrencyCode}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Exchang Rate"
                                      value={data?.ExchangeRate || ""}
                                      // value={data?.ExchangeRate}
                                      onChange={(e) => {
                                        updateFieldAndTotals(
                                          rows,
                                          data,
                                          "ExchangeRate",
                                          e.target.value
                                        );
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Amount"
                                      value={+data.Amount?.toFixed(2)}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Tax Amount"
                                      value={+data.TaxAmount?.toFixed(2)}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Withholding Tax"
                                      value={
                                        +data.WithholdingTaxAmount?.toFixed(2)
                                      }
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Total Amount"
                                      value={+data.TotalAmount?.toFixed(2)}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Amount"
                                      value={+data.AmountTHB?.toFixed(2)}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Tax Amount"
                                      value={+data.TaxAmountTHB?.toFixed(2)}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Withholding Tax"
                                      value={
                                        +data.WithholdingTaxAmountTHB?.toFixed(
                                          2
                                        )
                                      }
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      label="Total Amount"
                                      value={+data.TotalAmountTHB?.toFixed(2)}
                                    />
                                  </TableCell>

                                  <TableCell align="center">
                                    <Button
                                      type="button"
                                      variant="outlined"
                                      style={{
                                        color: "#80c340",
                                        borderColor: "#80c340",
                                      }}
                                      onClick={() => deletehand(data?.id)}
                                    >
                                      Delete
                                    </Button>
                                  </TableCell>
                                </TableBody>
                              );
                            })}
                          </Table>
                        </TableContainer>
                      </div>
                      <Table sx={{ marginBottom: "15px" }}>
                        <TableRow>
                          <TableCell align="center" width="40%"></TableCell>
                          <TableCell align="center" width="20%"></TableCell>
                          <TableCell align="center" width="30%"></TableCell>
                          <TableCell align="center" width="10%"></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={1} rowSpan={4} />
                          <TableCell colSpan={1}>
                            Total Amount (Excluding Tax)
                          </TableCell>
                          <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                            {parseFloat(
                              rows?.length > 1
                                ? rows
                                    ?.map((s) => s?.AmountTHB || 0)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? rows[0]?.AmountTHB.toFixed(2)
                                : 0,
                              10
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          </TableCell>
                          <TableCell colSpan={1}>THB</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={1}>Withholding Tax</TableCell>
                          <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                            {parseFloat(
                              rows?.length > 1
                                ? rows
                                    ?.map(
                                      (s) => s?.WithholdingTaxAmountTHB || 0
                                    )
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? rows[0]?.WithholdingTaxAmountTHB.toFixed(2)
                                : 0,
                              10
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          </TableCell>
                          <TableCell colSpan={1}>THB</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={1}>TotalTax</TableCell>
                          <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                            {parseFloat(
                              rows?.length > 1
                                ? rows
                                    ?.map((s) => s?.TaxAmountTHB || 0)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? rows[0]?.TaxAmountTHB.toFixed(2)
                                : 0,
                              10
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          </TableCell>
                          <TableCell colSpan={1}>THB</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={1}>TotalAmount</TableCell>
                          <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                            {parseFloat(
                              rows?.length > 1
                                ? rows
                                    ?.map((s) => s?.TotalAmountTHB || 0)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? (rows[0]?.TotalAmountTHB).toFixed(2)
                                : 0,
                              10
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          </TableCell>
                          <TableCell colSpan={1}>THB</TableCell>
                        </TableRow>
                      </Table>
                    </>
                  ) : (
                    <>
                      <div style={{ overflowX: "auto" }}>
                        <TableContainer
                          sx={{ marginTop: 2, marginBottom: 2, width: "200%" }}
                        >
                          <Table stickyHeader>
                            <TableRow>
                              <TableCell align="center" width="100px">
                                #
                              </TableCell>
                              <TableCell align="center" width="200px">
                                Charge
                              </TableCell>

                              <TableCell align="center" width="100px">
                                Tax%
                              </TableCell>
                              <TableCell align="center" width="150px">
                                Withholding Tax%
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Quantity
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Price / Unit
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Currency
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Exchang Rate
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Amount
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Tax Amount
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Withholding Tax
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Total Amount
                              </TableCell>
                              <TableCell align="center" width="100px">
                                Amount (THB)
                              </TableCell>
                              <TableCell align="center" width="120px">
                                Tax Amount (THB)
                              </TableCell>
                              <TableCell align="center" width="130px">
                                Withholding Tax (THB)
                              </TableCell>
                              <TableCell align="center" width="120px">
                                Total Amount (THB)
                              </TableCell>

                              {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                            </TableRow>

                            {x?.Detail?.map((data, index) => {
                        return (
                          <TableBody key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Charge"
                                value={data?.Charge}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Tax"
                                value={data?.TaxPercent}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Withholding Tax"
                                value={data?.WithholdingTaxPercent}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Quantity"
                                value={data?.Quantity}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Price/Unit"
                                value={data?.PricePerUnit}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Currency"
                                value={data?.CurrencyCode}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Exchang Rate"
                                value={data?.ExchangeRate}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Amount"
                                disabled
                                value={data?.Amount}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <TextField
                                label="Tax Amount"
                                disabled
                                value={data?.TaxPercent}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Withholding Tax"
                                disabled
                                value={data?.WithholdingTaxAmount}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Total Amount"
                                disabled
                                value={data?.TotalAmount}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Amount"
                                disabled
                                value={data?.AmountTHB}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <TextField
                                label="Tax Amount"
                                disabled
                                value={data?.TaxAmountTHB}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Withholding Tax"
                                disabled
                                value={data?.WithholdingTaxAmountTHB}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Total Amount"
                                disabled
                                value={data?.TotalAmountTHB}
                              />
                            </TableCell>
                          </TableBody>
                        );
                      })}
                          </Table>
                        </TableContainer>
                      </div>
                      <Table sx={{ marginBottom: "15px" }}>
                        <TableRow>
                          <TableCell align="center" width="40%"></TableCell>
                          <TableCell align="center" width="20%"></TableCell>
                          <TableCell align="center" width="30%"></TableCell>
                          <TableCell align="center" width="10%"></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={1} rowSpan={4} />
                          <TableCell colSpan={1}>
                            Total Amount (Excluding Tax)
                          </TableCell>
                          <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                            {parseFloat(
                              x?.Detail?.length > 1
                                ? x?.Detail?.map((s) => s?.AmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : x?.Detail?.length === 1
                                ? x?.Detail[0]?.AmountTHB.toFixed(2)
                                : 0,
                              10
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          </TableCell>
                          <TableCell colSpan={1}>THB</TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell colSpan={1}>Withholding Tax</TableCell>
                          <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                            {parseFloat(
                              x?.Detail?.length > 1
                                ? x?.Detail?.map(
                                    (s) => s?.WithholdingTaxAmountTHB
                                  )
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : x?.Detail?.length === 1
                                ? x?.Detail[0]?.WithholdingTaxAmountTHB.toFixed(
                                    2
                                  )
                                : 0,
                              10
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          </TableCell>
                          <TableCell colSpan={1}>THB</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={1}>TotalTax</TableCell>
                          <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                            {parseFloat(
                              x?.Detail?.length > 1
                                ? x?.Detail?.map((s) => s?.TaxAmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : x?.Detail?.length === 1
                                ? x?.Detail[0]?.TaxAmountTHB.toFixed(2)
                                : 0,
                              10
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          </TableCell>
                          <TableCell colSpan={1}>THB</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={1}>TotalAmount</TableCell>
                          <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                            {parseFloat(
                              x?.Detail?.length > 1
                                ? x?.Detail?.map((s) => s?.TotalAmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : x?.Detail?.length === 1
                                ? (x?.Detail[0]?.TotalAmountTHB).toFixed(2)
                                : 0,
                              10
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          </TableCell>
                          <TableCell colSpan={1}>THB</TableCell>
                        </TableRow>
                      </Table>
                    </>
                  )}
                  <Box sx={{ display: "flex", justifyContent: "end" }}>
                    <Box sx={{ display: "flex" }}>
                      {isEdit !== x?.TrainCostId ? (
                        <>
                          <Button
                            type="button"
                            variant="outlined"
                            disabled={loading}
                            style={{
                              color: "#3085d6",
                              borderColor: "#3085d6",
                              marginRight: "10px",
                              width: "200px",
                            }}
                            onClick={(e) => {
                              handleClick(e);
                              setBodyPrint({
                                ...bodyPrint,
                                CostId: x?.TrainCostId,
                              });
                            }}
                          >
                            {loading ? 'Loading...' : 'print'} 
                          </Button>
                          <Button
                            type="button"
                            variant="outlined"
                            style={{
                              color: "#d33",
                              borderColor: "#d33",
                              marginRight: "10px",
                            }}
                            onClick={() => {
                              const deleteCo = async () => {
                                const res = await api.post(
                                  `api/train/update/cost/delete`,
                                  {
                                    TrainCostId: x?.TrainCostId,
                                  }
                                );
                                if (res.meta.status) {
                                  Swal.fire({
                                    title: `${res.meta.message}`,
                                    icon: "success",
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "OK",
                                    allowOutsideClick: false,
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      setRows([]);
                                      setIsEdit(false);
                                      getCost();
                                    }
                                  });
                                }
                              };
                              Swal.fire({
                                title: "Are you sure?",
                                // text: "You won't be able to revert this!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, delete it!",
                                allowOutsideClick: false,
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  deleteCo();
                                }
                              });
                            }}
                          >
                            Delete
                          </Button>

                          <Button
                            type="button"
                            variant="contained"
                            style={{
                              background: "#80c340",
                              borderColor: "#80c340",
                            }}
                            onClick={() => {
                              const row = x?.Detail.map((y, i) => ({
                                id: i,
                                ...y,
                                TaxPercent: y.TaxPercent || "0",
                                WithholdingTaxPercent:
                                  y.WithholdingTaxPercent || "0",
                              }));
                              setRows(row);
                              setIsEdit(x?.TrainCostId);
                            }}
                          >
                            Edit
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            type="button"
                            variant="contained"
                            style={{
                              background: "#d33",
                              borderColor: "#d33",
                              marginRight: "10px",
                            }}
                            onClick={() => {
                              setRows([]);
                              setIsEdit(false);
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            // type="button"
                            variant="contained"
                            style={{
                              background: "#80c340",
                              borderColor: "#80c340",
                            }}
                            onClick={() => {
                              const body = {
                                TrainCostId: x?.TrainCostId,
                                VoyNo: voyNo,
                                InvoiceNo: x?.InvoiceNo,
                                IssueDate: moment(x?.IssueDate).format(
                                  "yyyy-MM-DD"
                                ),
                                BillTo: billTo?.CompanyName,
                                AgentName: x?.AgentName,
                                TotalTHB:
                                  rows?.length > 1
                                    ? rows
                                        ?.map((s) => s?.AmountTHB)
                                        ?.reduce((a, b) => a + b)
                                    : rows?.length === 1
                                    ? rows[0]?.AmountTHB
                                    : 0,
                                TaxAmountTHB:
                                  rows?.length > 1
                                    ? +rows
                                        ?.map((s) => s?.TaxAmountTHB)
                                        ?.reduce((a, b) => a + b)
                                        .toFixed(2)
                                    : rows?.length === 1
                                    ? +rows[0]?.TaxAmountTHB.toFixed(2)
                                    : 0,
                                WithholdingTaxAmountTHB:
                                  rows?.length > 1
                                    ? +rows
                                        ?.map((s) => s?.WithholdingTaxAmountTHB)
                                        ?.reduce((a, b) => a + b)
                                        .toFixed(2)
                                    : rows?.length === 1
                                    ? +rows[0]?.WithholdingTaxAmountTHB.toFixed(
                                        2
                                      )
                                    : 0,
                                TotalAmountTHB:
                                  rows?.length > 1
                                    ? +rows
                                        ?.map((s) => s?.TotalAmountTHB)
                                        ?.reduce((a, b) => a + b)
                                        .toFixed(2)
                                    : rows?.length === 1
                                    ? +(rows[0]?.TotalAmountTHB).toFixed(2)
                                    : 0,
                                Status: true,
                                Detail: rows,
                              };
                              const postInvoice = async () => {
                                const res = await api.post(
                                  `api/train/update/cost/invoice`,
                                  body
                                );
                                if (res.meta.status) {
                                  Swal.fire({
                                    title: `${res.meta.message}`,
                                    icon: "success",
                                    confirmButtonColor: "#3085d6",
                                    confirmButtonText: "OK",
                                    allowOutsideClick: false,
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      setRows([]);
                                      setIsEdit(false);
                                      getCost();
                                    }
                                  });
                                }
                              };

                              postInvoice();
                            }}
                          >
                            Update
                          </Button>
                        </>
                      )}
                    </Box>
                  </Box>
                </Card>
              ))}
            </Box>
          </Grid>
        </Card>
      </LocalizationProvider>
      <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
           {masterCompany?.map((item) => {
            return (
              <MenuItem 
              onClick={() => {
                download(
                  bodyPrint.CostType,
                  bodyPrint.CostId,
                  item.CompanyCode
                );
                handleClose();
              }}>{item.CompanyName}</MenuItem>
            )
           })}
        </Menu>
    </div>
  );
}
